import { nanoid } from 'nanoid';

const AUTH_DEVICE_KEY = 'auth-device';

export function getAuthDevice(): string {
	let device = localStorage.getItem(AUTH_DEVICE_KEY);
	if (!device) {
		device = nanoid();
		localStorage.setItem(AUTH_DEVICE_KEY, device);
	}
	return `mute-backoffice:${device}`;
}
